export default "__VITE_ASSET__BhihBBsX__"